import { cn } from "@/lib/utils"

interface GlassCardProps {
  children: React.ReactNode
  className?: string
  blur?: 'sm' | 'md' | 'lg'
  opacity?: 'low' | 'medium' | 'high'
}

export function GlassCard({ 
  children, 
  className, 
  blur = 'md',
  opacity = 'medium'
}: GlassCardProps) {
  const blurClasses = {
    sm: 'backdrop-blur-sm',
    md: 'backdrop-blur-md', 
    lg: 'backdrop-blur-lg'
  }

  const opacityClasses = {
    low: 'bg-white/5 border-white/10',
    medium: 'bg-white/10 border-white/20',
    high: 'bg-white/20 border-white/30'
  }

  return (
    <div
      className={cn(
        "rounded-lg border transition-all duration-300",
        "hover:bg-white/15 hover:border-white/30",
        blurClasses[blur],
        opacityClasses[opacity],
        className
      )}
    >
      {children}
    </div>
  )
}

interface FloatingElementProps {
  children: React.ReactNode
  className?: string
  delay?: number
}

export function FloatingElement({ 
  children, 
  className, 
  delay = 0 
}: FloatingElementProps) {
  return (
    <div
      className={cn(
        "animate-bounce",
        className
      )}
      style={{
        animationDelay: `${delay}ms`,
        animationDuration: '3s',
        animationIterationCount: 'infinite'
      }}
    >
      {children}
    </div>
  )
}